import { onVisibleCallback, TruncatePostP } from './modules/helpers';

window.app = {};
window.qOne = document.querySelector.bind(document);
window.qAll = document.querySelectorAll.bind(document);
import { init as modalsInit } from './modules/modals';
import { init as slidersInit } from './modules/sliders';
import { Reviews, Portfolio } from './modules/modules';
import { initContactAnchor } from './modules/contact-anchor';

modalsInit();
slidersInit();
initContactAnchor();

document.addEventListener('click', (e) => {
  e.target.matches('.scroll-to-top') &&
    window.scrollTo({ top: 0, behavior: 'smooth' });
});

//mobile nav
document.addEventListener('click', (e) => {
  if (
    !e.target.parentNode.matches('.mobile-menu .menu-item-has-children') ||
    e.target.parentNode.matches('.menu-item-has-children.open')
  ) {
    return;
  }

  e.target.parentNode.classList.add('open');
  e.preventDefault();
});

qAll('.post-mini p').forEach((el) => new TruncatePostP(el));
qAll('.reviews').forEach((el) => new Reviews(el));
qAll('.portfolio').forEach((el) => new Portfolio(el));

const collapseText = (el) => {
  el.preventDefault();
  let txt = el.target.textContent;
  el.target.textContent = txt === 'Read more +' ? 'Hide -' : 'Read more +';

  const collapsedText = el.target.parentNode.querySelector('.collapsed-text');
  if (txt === 'Read more +') {
    collapsedText.style.maxHeight = collapsedText.scrollHeight + 'px';
  } else {
    collapsedText.removeAttribute('style');
  }
};
qAll('.collapse-text').forEach((el) => {
  el.addEventListener('click', collapseText);
});

qAll('.contact-map').forEach((el) => {
  onVisibleCallback({
    element: el.parentElement,
    once: true,
    callback: () => {
      el.style.display = 'block';
    },
  });
});

document.addEventListener('DOMContentLoaded', (e) => {
  const video = document.querySelector('.hero .embed-video video');
  if (video) {
    const videoSrc = video.dataset.src;
    video.setAttribute('src', videoSrc);
  }
});
